var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "campaigns-wrapper"
  }, [_c('div', {
    staticClass: "campaigns-header d-flex justify-content-center align-center px-20 px-sm-30"
  }, [_c('div', {
    staticClass: "campaigns-container px-20 mx-auto relative"
  }, [_c('a', {
    staticClass: "mobile-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$router.back();
      }
    }
  }, [_c('div', {
    staticClass: "mobile-back-btn Arrow-Macro"
  })]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.pageTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "campaigns-body py-20 py-sm-30 py-lg-40 px-20 px-sm-30"
  }, [_c('div', {
    staticClass: "campaigns-container mx-auto"
  }, [_c('div', {
    staticClass: "campaigns-content d-md-grid grid-cols-md-12 gap-md-30"
  }, [_c('div', {
    staticClass: "col-span-md-12 col-span-lg-8 col-start-lg-3",
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }